import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Button } from "reactstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const EVENT_DESCRIPTIONS = {
  "checkout.session.completed": "Fires when a customer completes checkout.",
  "customer.subscription.created": "Fires when a new subscription is created.",
  "customer.subscription.updated": "Fires when a subscription is changed.",
  "customer.subscription.deleted": "Fires when a subscription is cancelled.",
  "invoice.paid": "Fires when an invoice payment succeeds.",
  "invoice.payment_failed": "Fires when an invoice payment fails.",
};

const getEventCategory = (event) => {
  if (event.includes("subscription")) return "Subscription";
  if (event.includes("invoice")) return "Invoice";
  if (event.includes("checkout")) return "Checkout";
  if (event.includes("customer")) return "Customer";
  if (event.includes("payment")) return "Payment";
  return "Billing";
};

const StripeSubscriptionConfigEventsTable = ({ events, webhookReady }) => {
  const tableData = (events || []).map((event) => ({
    id: event,
    event,
    category: getEventCategory(event),
    description: EVENT_DESCRIPTIONS[event] || "Required for subscription billing sync.",
    active: webhookReady,
  }));

  const eventFormatter = (cell, row) => (
    <>
      <span className="fontWeight700 stripe-event-name">{cell}</span>
      <div className="text-muted" style={{ fontSize: "0.85rem" }}>{row.description}</div>
    </>
  );

  const categoryFormatter = (cell) => <span>{cell}</span>;

  const statusFormatter = (cell) => {
    const color = cell ? "success" : "warning";
    const label = cell ? "Subscribed" : "Pending";
    return (
      <Button className="btn-status stripe-status-pill" disabled color={color}>
        <b>{label}</b>
      </Button>
    );
  };

  const columns = [
    {
      dataField: "event",
      text: "Event",
      formatter: eventFormatter,
      headerStyle: () => ({ width: "62%" }),
      style: () => ({ width: "62%" }),
    },
    {
      dataField: "category",
      text: "Category",
      formatter: categoryFormatter,
      headerStyle: () => ({ width: "18%" }),
      style: () => ({ width: "18%" }),
    },
    {
      dataField: "active",
      text: "Status",
      formatter: statusFormatter,
      headerStyle: () => ({ width: "20%" }),
      style: () => ({ width: "20%" }),
    },
  ];

  return (
    <BootstrapTable
      keyField="id"
      data={tableData}
      columns={columns}
      bordered={false}
    />
  );
};

export default StripeSubscriptionConfigEventsTable;
